/**
 * Remove invalid values from array.
 * @param data
 * @param returnType
 * @param defaultValue
 * @returns {{length}|*|string|string} the filtered array items if truthy, else the default value
 */
const stripInvalidValue = (data, returnType, defaultValue = null) => {
    if (!defaultValue) {
        switch (returnType) {
            case 'string':
                defaultValue = '';
                break;
            case 'number':
                defaultValue = 0;
                break;
            case 'boolean':
                defaultValue = false;
                break;
            case 'array':
                defaultValue = [];
                break;
            case 'object':
                defaultValue = {};
                break;
        }
    }

    if (!data) {
        return defaultValue;
    }

    if (Array.isArray(data)) {
        const result = data.filter(value => !!value);

        if (result.length) {
            if (returnType === 'array') {
                return result;
            } else {
                return result[0];
            }
        } else {
            return defaultValue;
        }
    }

    return data;
};

const AppUtil = {
    stripInvalidValue
};

export default AppUtil;
